import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CTASection from './components/CTASection';
import TrustedBrands from './components/TrustedBrands';
import WhyChooseUs from './components/WhyChooseUs';
import FeaturedProducts from './components/FeaturedProducts';
import Footer from './components/Footer';
import Products from './components/Products';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import './App.css';

function App() {
  const getCurrentPage = () => {
    const hash = window.location.hash.slice(1);
    if (hash === 'products') {
      return 'products';
    } else if (hash === 'about') {
      return 'about';
    } else if (hash === 'contact') {
      return 'contact';
    }
    return 'home';
  };

  const [currentPage, setCurrentPage] = useState(getCurrentPage());

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentPage(getCurrentPage());
    };

    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  // Scroll to top whenever page changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [currentPage]);

  return (
    <div className="App">
      <Navbar />
      {currentPage === 'products' ? (
        <Products />
      ) : currentPage === 'about' ? (
        <AboutUs />
      ) : currentPage === 'contact' ? (
        <ContactUs />
      ) : (
        <>
          <HeroSection />
          <CTASection />
          <WhyChooseUs />
          <FeaturedProducts />
          <TrustedBrands />
        </>
      )}
      <Footer />
    </div>
  );
}

export default App;

